import { createFileRoute } from '@tanstack/react-router';
import { doNothing } from 'remeda';

import { ContentTypes } from '@@api/utils/schemas/schemas';
import { overviewListQuery } from '@@components/OverviewList/overviewListQuery';
import { overviewListSearchParams } from '@@components/OverviewList/overviewListSearchParams';
import { restoreSavedFilters } from '@@containers/Search/restoreSavedFilters';
import { getContentLocale } from '@@scripts/store/settings/useSettingsStore';

import { VideoList } from './-components/VideoList';

export const Route = createFileRoute('/_authenticated/externalContent/videos/')({
    validateSearch: overviewListSearchParams,
    // A new search makes a new match, which runs the loader again
    loaderDeps: ({ search }) => overviewListSearchParams.parse(search),
    beforeLoad: ({ cause, location, search }) => {
        restoreSavedFilters({ cause, location, search }, overviewListSearchParams, 'default');

        // Built on every load, so the options follow the content language as well as the search
        return {
            listQuery: overviewListQuery(ContentTypes.VIDEOS, search, getContentLocale()),
        };
    },
    loader: ({ context }) => {
        context.queryClient.query(context.listQuery).catch(doNothing());
    },
    component: VideoList,
});
